import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './language-selector.module.css';
import { portalLanguages } from '../../translation/languages';

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };
  return (
    <div className={styles['language-selector']}>
      {portalLanguages.map((lang) => (
        <span
          key={lang.code}
          className={i18n.language === lang.code ? styles['active'] : ''}
          onClick={() => handleLanguageChange(lang.code)}
        >
          {lang.label}
        </span>
      ))}
    </div>
  );
};
